// extracted by mini-css-extract-plugin
export default {"spinner_container":"loading_spinner_container__2oxgp","spinner":"loading_spinner__6bY4o","spin":"loading_spin__Qhera"};